import AccordionBlock from 'libs/wordpress/content/cmsBlocks/AccordionBlock';
import React from 'react';
import styled from 'libs/styled';

const Section = styled('section')``;

const AccordionLayout = ({ ...rest }) => (
    <Section mb={['48px', null, null, '64px']}>
        <AccordionBlock {...rest} />
    </Section>
);

export default AccordionLayout;
